import { useState } from "react";
import { createPortal } from "react-dom";
import { useDispatch } from "react-redux";

import { deleteStudentList } from "../../studentSlice";

import { Button } from "../../../../components/Button";

const DeleteStudentButton = ({ students, setSelectedStudents }) => {
  const dispatch = useDispatch();

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const handleDeleteClick = () => {
    setIsDeleteModalOpen(true);
  };

  // [추가] 실제 삭제 로직
  // 결과를 반드시 알린다. 예전에는 실패해도 조용히 목록만 그대로여서, 학생이
  // 한 명도 안 지워졌는데 무엇이 잘못됐는지 알 방법이 없었다.
  const confirmDelete = async () => {
    const result = await dispatch(
      deleteStudentList({
        studentIds: students.map((student) => student.id),
      })
    );

    setIsDeleteModalOpen(false);

    if (!deleteStudentList.fulfilled.match(result)) {
      alert("학생 삭제에 실패했습니다. 다시 시도해주세요.");
      return;
    }

    const { successfulIds, missingIds } = result.payload;
    setSelectedStudents([]);

    if (missingIds.length > 0) {
      alert(
        `${successfulIds.length}명을 삭제했습니다. ` +
          `${missingIds.length}명은 이미 삭제됐거나 찾지 못했습니다.`
      );
      return;
    }

    alert(`${successfulIds.length}명을 삭제했습니다.`);
  };

  // [추가] 삭제 모달 닫기
  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const styles = {
    modalOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      color: "#000",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
    },
    modalContent: {
      backgroundColor: "#fff",
      padding: "20px",
      borderRadius: "8px",
      width: "300px",
      maxWidth: "90%",
    },
    modalHeader: {
      textAlign: "center",
      fontSize: "16px",
      marginBottom: "40px",
    },
    modalBody: {
      marginBottom: "40px",
      lineHeight: "1.0",
    },
    modalFooter: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },
    dangerButton: {
      backgroundColor: "#FF4444",
      color: "#fff",
      border: "none",
      padding: "6px 12px",
      width: "100%",
      cursor: "pointer",
      borderRadius: "4px",
    },
    cancelButton: {
      backgroundColor: "#EBEBEB",
      color: "#737373",
      border: "none",
      padding: "6px 12px",
      cursor: "pointer",
      width: "100%",
      borderRadius: "4px",
    },
  };

  return (
    <div>
      <Button
        backgroundColor="#FFFFFF"
        color="#FF4444"
        border="1px solid #EBEBEB"
        fontSize="16px"
        padding="10px 35px"
        onClick={() => handleDeleteClick()}
      >
        삭제하기
      </Button>

      {/*
        모달은 body 에 직접 그린다. 이 버튼을 담고 있는 선택 바가
        `transform: translateX(-50%)` 를 쓰는데, transform 이 걸린 요소는 그 안의
        `position: fixed` 의 기준이 되어 버린다. 그래서 화면 전체를 덮어야 할
        모달이 선택 바의 왼쪽 위를 기준으로 그려져 대부분 화면 밖으로 나갔고,
        누르는 사람에게는 '삭제하기를 눌러도 아무 일도 안 일어나는' 것으로 보였다.
      */}
      {isDeleteModalOpen &&
        createPortal(
          <div style={styles.modalOverlay} onClick={closeDeleteModal}>
            <div
              style={styles.modalContent}
              onClick={(e) => e.stopPropagation()}
            >
              <div style={styles.modalHeader}>학생 삭제</div>
              <div style={styles.modalBody}>
                <strong style={{ textAlign: "center" }}>
                  정말 {students[0].name} 외 {students.length - 1}명의 학생 정보를
                </strong>
                <p>
                  <strong style={{ textAlign: "center" }}>
                    삭제하시겠습니까?
                  </strong>
                </p>
              </div>
              <div style={styles.modalFooter}>
                <button style={styles.dangerButton} onClick={confirmDelete}>
                  네
                </button>
                <button style={styles.cancelButton} onClick={closeDeleteModal}>
                  아니오
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}
    </div>
  );
};

export default DeleteStudentButton;
